import type {
  HiveInfo,
  OrganizationHivesResponse,
  UserEmail,
  UserInfo,
} from '@/generated/http-clients/v2ApiSchemas'

type FlattenedHivesResponseItem = HiveInfo & {
  org_id: string
  company_name?: string
  stripe_id?: string
  emails: UserEmail[]
  users: UserInfo[]
}

export type FlattenedHivesResponse = FlattenedHivesResponseItem[]

export const flattenHivesResponse = (
  data: OrganizationHivesResponse[] | undefined,
): FlattenedHivesResponse => {
  if (!data) {
    return []
  }

  return data.reduce<FlattenedHivesResponse>(
    (
      accumulator,
      {
        org_id,
        company_name,
        stripe_id,
        hives_info = [],
        users_info = [],
        email = [],
      },
    ) => {
      accumulator.push(
        ...hives_info.map((hive_info) => ({
          ...hive_info,
          org_id,
          company_name,
          stripe_id,
          users: users_info ?? [],
          emails: email ?? [],
        })),
      )
      return accumulator
    },
    [],
  )
}

export const flattenOrganizationHivesResponse = (
  data: OrganizationHivesResponse | undefined,
):
  | Array<{
      org_id: string
      company_name?: string
      stripe_id?: string
      email: UserEmail | null
      user_info: UserInfo | null
      hive_info: HiveInfo | null
    }>
  | undefined => {
  if (!data) {
    return undefined
  }

  const {
    org_id,
    company_name,
    stripe_id,
    hives_info = [],
    users_info = [],
    email = [],
  } = data

  const maxLength = Math.max(hives_info.length, users_info.length, email.length)

  return Array.from({ length: maxLength }, (_, i) => ({
    org_id,
    company_name,
    stripe_id,
    hive_info: hives_info[i] || null,
    user_info: users_info[i] || null,
    email: email[i] || null,
  }))
}

/**
 *
 * "RUNNING" | "PENDING" | "ERROR" | "DELETING" | "LOCKED"
 * @param status the input status
 */
export function getColorSchemeForStatus(status: string | undefined) {
  if (status === 'RUNNING') {
    return 'green'
  }
  if (status === 'PENDING') {
    return 'orange'
  }
  if (status === 'ERROR') {
    return 'red'
  }
  if (status === 'DELETING') {
    return 'red'
  }
  if (status === 'LOCKED') {
    return 'blue'
  }
  return 'orange'
}
